import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { GuardShiftDetails } from '../../../../../types';
import { ApiClient } from '../../../../api-client';
import { UnitResult } from '../../../../error';
import { GetGuardShiftDetails } from '../../../Domain/Port/GetGuardShiftDetails/get-guard-shift.details';

@Injectable({
    providedIn: 'root'
})
export class BackendGetGuardShiftDetailsService extends GetGuardShiftDetails {
    constructor(private apiClient: ApiClient) {
        super();
    }

    override execute(id: number): Observable<UnitResult<GuardShiftDetails>> {
        return this.apiClient.get<GuardShiftDetails>(`/shift/${id}`, false);
    }
}
